<template>
    <div v-if="mobile" id="collaborations" class="mobile">
<!--image container-->
        <div class="random-container" v-if="current" @click="reRenderStackMobile()">
            <ImageLoader class="object z" v-for="object in imageArray" :key="object.uuid" v-memo="[imageArray, rerender]"
                         :style="{ transform: randomPlacementMobile(object.size)}"
                         :class="[ object.partOf, object.size ]"
                         :small="$store.state.$imageBaseURL + object.id + '/' + object.cover + '?w=8&q=50&dpr=2&token=' + $store.state.$imageToken"
                         :trueSize="getImageUrl(object)"
                          :collabPage="true"
                          :collabSize="collabSize"
                         lazyload="lazy"/>
        </div>

        <!--        description container-->
        <Transition>
            <div id="description-text">
                <div id="description-content" v-show="current" v-html="descriptionContent"></div>
            </div>
        </Transition>

        <!--        clients container-->
        <div id="clients-container">
<!--            <div v-show="showList" id="clients">-->
<!--                <div v-for="object in sorted" :key="object.id" @mouseenter="setZindex(object.slug)"-->
<!--                   :id="object.slug">-->
<!--                    <p class="client-name" style="display: inline-block;" @click="showDescription(object)"-->
<!--                    :style="{ opacity: (popup && object.slug === current) || !popup ? '1' : '0' }">{{ object.title }}</p>-->
<!--                </div>-->
<!--            </div>-->

            <swiper
                v-show="showList" id="clients"
                :slides-per-view="3"
                :space-between="0"
                :navigation="false"
                :pagination="true"
                :centered-slides="false"
                ref="mySwiper"
                :key="swiperRender"
            >
                <swiper-slide v-for="object in sorted" :key="object.id" :id="object.slug">
                    <p class="client-name" style="display: inline-block;" @click="fetchImagesMobile(object); this.current = object.slug; showDescription(object)"
                       :style="{
                          fontStyle: object.slug === current ? 'italic' : 'normal',
                          fontWeight: object.slug === current ? 'bold' : 'normal',
                          opacity: object.slug === current ? '1' : '0.7'
                    }">{{ object.title }}</p>
                </swiper-slide>

            </swiper>

            <svg v-show="!showList" id="loading-spinner" viewBox="0 0 800 800" width="100" height="100" xmlns="http://www.w3.org/2000/svg">
                <circle class="spin" cx="400" cy="400" fill="none"
                        r="200" stroke-width="25" stroke="grey"
                        stroke-dasharray="700 1400"
                        stroke-linecap="round" />
            </svg>
        </div>
    </div>

<!--  desktop version-->
    <div v-else id="collaborations">
        <!--        image container-->
        <div class="random-container" v-if="imageArray" @click="reRenderStack()">
            <ImageLoader class="object z" v-for="object in imageArray" :key="object.uuid" v-memo="[imageArray, rerender]"
                         :style="{ transform: randomPlacement(object.size) }"
                         :class="[ object.partOf, object.size ]"
                         :small="$store.state.$imageBaseURL + object.id + '/' + object.cover + '?w=8&q=50&dpr=2&token=' + $store.state.$imageToken"
                         :trueSize="getImageUrl(object)"
                         :collabPage="true"
            :collabSize="collabSize"
                         @click="showLightbox($event, object)"
                         lazyload="lazy"/>
        </div>

      <div v-if="lightboxImage" id="image-lightbox">
        <div id="lightbox-backdrop"></div>
        <ImageLoader id="lightbox-image" :small="$store.state.$imageBaseURL + lightboxImage.id + '/' + lightboxImage.cover + '?w=8&q=50&dpr=2&token=' + $store.state.$imageToken"
                     :trueSize="getImageUrl(lightboxImage)"/>
      </div>

        <!--        description container-->
        <Transition>
            <div id="description-text">
                <p class="buttons">
                    <svg id="close" @click="closePopup()"
                         :style="{ opacity: popup || lightboxImage ? '1' : '0',
                                   pointerEvents: popup || lightboxImage ? 'all' : 'none'}"
                         xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="36"
                         height="36" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none"
                         stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <line x1="18" y1="6" x2="6" y2="18"/>
                        <line x1="6" y1="6" x2="18" y2="18"/>
                    </svg>
                </p>
                <div id="description-content" v-show="descriptionContent !== ''" v-html="descriptionContent"></div>
            </div>
        </Transition>

        <!--        clients container-->
        <div id="clients-container">
            <div v-if="showList" id="clients">
                <div v-for="object in sorted" :key="object.id" @mouseenter="setZindex(object.slug); showDescription(object);"
                     :id="object.slug">
                    <p class="client-name" style="display: inline-block;" @click="popup = true"
                       :style="{ opacity: (popup && object.slug === current) || !popup ? '1' : '0' }">{{ object.title }}</p>

                    <!--                    <svg @click="reRenderStack()"-->
                    <!--                         style="user-select: none; display: inline;"-->
                    <!--                         :style="{ opacity: popup && object.slug === current ? '1' : '0',-->
                    <!--                                    pointerEvents: popup && object.slug === current ? 'all' : 'none'}"-->
                    <!--                         xmlns="http://www.w3.org/2000/svg"-->
                    <!--                         class="icon icon-tabler icon-tabler-refresh extra-refresh-icon" width="36" height="36" viewBox="0 0 24 24"-->
                    <!--                         stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">-->
                    <!--                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>-->
                    <!--                        <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"/>-->
                    <!--                        <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/>-->
                    <!--                    </svg>-->
                    <svg id="close" @click="closePopup()"
                         :style="{ opacity: popup && object.slug === current ? '1' : '0',
                                   pointerEvents: popup && object.slug === current ? 'all' : 'none'}"
                         xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x extra-refresh-icon" width="36"
                         height="36" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none"
                         stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <line x1="18" y1="6" x2="6" y2="18"/>
                        <line x1="6" y1="6" x2="18" y2="18"/>
                    </svg>
                </div>
            </div>
            <svg v-else id="loading-spinner" viewBox="0 0 800 800" width="100" height="100" xmlns="http://www.w3.org/2000/svg">
                <circle class="spin" cx="400" cy="400" fill="none"
                        r="200" stroke-width="25" stroke="grey"
                        stroke-dasharray="700 1400"
                        stroke-linecap="round" />
            </svg>
        </div>
    </div>
</template>

<script>
// import Swiper core and required components
import SwiperCore, { Navigation, Pagination, A11y } from "swiper";

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";

// install Swiper components
SwiperCore.use([Navigation, Pagination, A11y]);

import ImageLoader from '../components/ImageLoader.vue'

export default {
    name: 'Home',
    components: {
        ImageLoader,  Swiper,
        SwiperSlide
    },
    data() {
        return {
            imageArray: [],
            clientArray: [],
            swiperRender: false,
            last: null,
            currentCollection: HTMLCollection,
            lastCollection: HTMLCollection,
            zIterator: 1,
            popup: false,
            rerender: 0,
            descriptionContent: "",
            showList: false,
          collabSize: null,
          lightboxImage: null,
          zIndexOffset: 0,
          current: null
        }
    },
    mounted() {
      if (this.mobile) {
        this.fetchContentMobile();
      } else {
        this.fetchContentDesktop();
      }
    },
    computed: {
        sorted() {
            return this.clientArray.slice().sort((a, b) => a.sort_index - b.sort_index);
        },
        mobile() {
            return this.$store.state.$mobile;
        }
    },
    watch: {
      sorted(newVal) {
        if (this.mobile && newVal && newVal.length) {
          this.fetchImagesMobile(newVal[0]);

          if (this.mobile) {
            this.current = this.sorted[0].slug;
            this.showDescription(this.sorted[0]);
          } else {
            this.current = null;
          }
        }
      }
    },
    methods: {
        onClickOutside(element, callback) {
          function handler(event) {
            if (!element.contains(event.target)) {
              callback(event);
            }
          }
          document.addEventListener("click", handler);

          return () => document.removeEventListener("click", handler);
        },
        showLightbox(event, object) {
          if (object.partOf === this.current) {
            event.stopPropagation();
            this.lightboxImage = object;
          } else if (this.popup) {
            this.closePopup();
          }
        },
        getImageUrl(object) {
            if (this.mobile) {
                return this.$store.state.$imageBaseURL + object.id + '/' + object.cover + '?w=240&q=100&dpr=2&token=' + this.$store.state.$imageToken;
            } else {
                return this.$store.state.$imageBaseURL + object.id + '/' + object.cover + '?w=480&q=100&dpr=2&token=' + this.$store.state.$imageToken;
            }
        },
        closePopup() {
            this.popup = false;
            this.lightboxImage = null;
        },
        randomPlacement(size) {
            let sizeMap;
                sizeMap = {
                    "small": 280,
                    "medium": 330,
                    "large": 400
                };
              this.collabSize = sizeMap[size];

              let x = Math.random() * (window.innerWidth - sizeMap[size] - 40) + 20;
              let y = Math.random() * (window.innerHeight - sizeMap[size] - 120) + 20;

              return `translate(${x}px, ${y}px)`
        },
      randomPlacementMobile(size) {
        let sizeMap;
          sizeMap = {
            "small": 260,
            "medium": 300,
            "large": 330
          };

        this.collabSize = sizeMap[size];

        const padding = 25;
        const maxX = window.innerWidth - sizeMap[size] - padding;
        const minX = padding;

        let x = Math.random() * (maxX - minX) + minX;

          // let x = Math.random() * window.innerWidth - (sizeMap[size] - 20)  + 25;
          let y = Math.random() * (window.innerHeight - sizeMap[size] - 220) + 50;

          return `translate(${x}px, ${y}px)`
      },
        setZindex(name) {
            if (!this.popup || this.mobile) {
                this.last = this.current;
                this.current = name;

                this.lastCollection = this.currentCollection;

                this.currentCollection = document.getElementsByClassName(name);

                console.log(this.currentCollection);


                if (this.last != null) {
                    for (let item of this.lastCollection) {
                        item.style.opacity = 0.6;
                        item.style.backgroundColor = '#fff';
                        item.style.mixBlendMode = "soft-light";
                        item.style.zIndex = 0;
                    }
                }

                Array.from(this.currentCollection).forEach((item, index) => {
                    const visualIndex = (index + this.zIndexOffset) % this.currentCollection.length;

                    item.style.opacity = 1;
                    item.style.backgroundColor = '#000';
                    item.style.mixBlendMode = "normal";
                    item.style.zIndex = visualIndex + 1;
                });

                this.zIndexOffset = (this.zIndexOffset + 1) % this.currentCollection.length;
            }
        },
      setInitialZindexMobile() {
          this.currentCollection = document.getElementsByClassName(this.current);

          console.log(this.currentCollection);
          Array.from(this.currentCollection).forEach((item, index) => {
            const visualIndex = (index + this.zIndexOffset) % this.currentCollection.length;

            item.style.opacity = 1;
            item.style.backgroundColor = '#000';
            item.style.mixBlendMode = "normal";
            item.style.zIndex = visualIndex + 1;
          });

          this.zIndexOffset = (this.zIndexOffset + 1) % this.currentCollection.length;
      },
        showDescription(object) {
          if (!this.popup) {
            if (object.fieldset === "folder") {
              this.descriptionContent = object.content;
            } else {
              const client = this.clientArray.find((element) => element.slug === object.partOf);
              this.descriptionContent = client.content;
            }
          }
        },
        reRenderStack() {
            let itemsArray = Array.from(this.currentCollection);
            let lastZIndex = itemsArray[itemsArray.length - 1].style.zIndex;

            for (let i = itemsArray.length - 1; i > 0; i--) {
              console.log(itemsArray[i].style.zIndex);
                itemsArray[i].style.zIndex = itemsArray[i - 1].style.zIndex;
            }

            itemsArray[0].style.zIndex = lastZIndex;
            this.rerender++;
        },
      reRenderStackMobile() {
        let itemsArray = Array.from(document.getElementsByClassName(this.current));

        let lastZIndex = itemsArray[itemsArray.length - 1].style.zIndex;

        console.log(lastZIndex);

        for (let i = itemsArray.length - 1; i > 0; i--) {
          itemsArray[i].style.zIndex = itemsArray[i - 1].style.zIndex;
        }

        itemsArray[0].style.zIndex = lastZIndex;
        this.rerender++;
      },
        async fetchContentDesktop() {
            try {
                // Fetch the main collaboration data
                let response = await fetch(`https://marinkagrondel.com/cms/api/entries?id=photo-series/collaborations&options[collection]=true&token=${process.env.VUE_APP_ENTRY_TOKEN}`);
                let data = await response.json();

                if (!data || !data.data) {
                    console.error("No collaboration projects available.");
                    return;
                }

                // Array to hold the image data promises
                const imagePromises = [];

                // Loop through the collaborations and fetch image data
                for (let collab in data.data) {
                    this.clientArray.push(data.data[collab]);

                    // Add the image fetch to the promises array
                    imagePromises.push(
                        fetch(`https://marinkagrondel.com/cms/api/entries?id=${collab}&options[collection]=true&token=${process.env.VUE_APP_ENTRY_TOKEN}`)
                            .then(imageResponse => imageResponse.json())
                            .then(imageData => {
                                if (imageData && imageData.data) {
                                    let entries = Object.values(imageData.data);
                                    entries.forEach((entry) => {
                                        entry.partOf = data.data[collab].slug;
                                        this.imageArray.push(entry);
                                    });
                                }
                            })
                    );
                }

                // Wait for all image data to be fetched
                await Promise.all(imagePromises);

                // After all data is fetched and processed, perform the final action
                this.showList = true;
                this.swiperRender = true; // Call the method or action that needs to happen after all data is loaded
                const popup = document.getElementById("description-text");

                this.onClickOutside(popup, () => {
                  this.closePopup();
                });

            } catch (error) {
                console.error("Error fetching content:", error);
            }
        },
        async fetchContentMobile() {
          try {
            // Fetch the main collaboration data
            let response = await fetch(`https://marinkagrondel.com/cms/api/entries?id=photo-series/collaborations&options[collection]=true&token=${process.env.VUE_APP_ENTRY_TOKEN}`);
            let data = await response.json();

            if (!data || !data.data) {
              console.error("No collaboration projects available.");
              return;
            }

            // Loop through the collaborations and fetch image data
            for (let collab in data.data) {
              this.clientArray.push(data.data[collab]);
            }

            this.showList = true;
            this.swiperRender = true;

          } catch (error) {
            console.error("Error fetching content:", error);
          }
        },
        async fetchImagesMobile(collab) {
          this.imageArray = [];

          const imageArrayPromises = [];

          imageArrayPromises.push(
              fetch(`https://marinkagrondel.com/cms/api/entries?id=${collab.id}&options[collection]=true&token=${process.env.VUE_APP_ENTRY_TOKEN}`)
                  .then(imageResponse => imageResponse.json())
                  .then(imageData => {
                    if (imageData && imageData.data) {
                      let entries = Object.values(imageData.data);
                      entries.forEach((entry) => {
                        entry.partOf = collab.slug;
                        this.imageArray.push(entry);
                      });
                    }
                  })
          );

          await Promise.all(imageArrayPromises);
          this.setInitialZindexMobile(collab.slug);
        }
    }
}
</script>

<style scoped>



#image-lightbox {
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  align-content: center;
  padding: 25px;
}

#image-lightbox img {
  max-width: calc(100% - 600px);
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

#lightbox-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 242, 188, 0.7);
  pointer-events: none;
  z-index: 999;
}

#lightbox-image {
  z-index: 1000;
}

#description-text {
  z-index: 1001;
}


#clients-container #loading-spinner {
    position: relative;
    width: 100%;
    height: 50px;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.spin {
    transform-origin: center;
    animation: spin 2s linear infinite;
}

#collaborations {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

#collaborations {
    p, a, h2, h3, h4, input::placeholder, input, input:-webkit-autofill, input:-webkit-autofill:focus {
        color: var(--secondary-text-color);
    }
}


#clients-container {
    position: relative;
    width: 100%;
    margin: 0 auto;
    max-width: 1400px;
    padding: 18px;
    padding-bottom: 32px;
    z-index: 100;
}

.mobile #clients-container {
    padding: 0;
    padding-bottom: 12px;
    font-size: 18px;
}

#clients {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
    align-content: flex-start;
    font-style: normal;
}

.swiper-slide {
    padding-top: 18px;
    padding-bottom: 14px;
    display: flex;
    padding-left: 10px;
    padding-right: 5px;
}

.swiper-slide:last-of-type {
  padding-right: 10px;
}

.mobile #clients {
    width: unset;
    flex-wrap: nowrap;
}

#clients .extra-refresh-icon {
    position: relative;
    opacity: 0;
    pointer-events: none;
    top: 4px;
    width: 0.8rem;
    height: 0.8rem;
}

#clients p {
    transition: opacity 0.5s;
}

#clients p:hover {
    font-style: italic;
}


.icon-tabler-refresh {
    width: 1.25rem;
    height: 1.25rem;
    margin-top: -0.1em;
    stroke-width: 1.5;
    stroke: var(--border-color);
    transition: transform 0.5s, opacity 0.5s;
    transform: translateY(22%);
}

.extra-refresh-icon {
    width: 1rem;
    height: 1rem;
}

.icon-tabler-refresh:hover, .icon-tabler-x:hover {
    stroke: rgba(var(--border-color-rgb), 0.2);
}

.icon-tabler-refresh:hover {
    transform: translateY(22%) rotate(-45deg);
}

#close {
    cursor: pointer;
    margin-top:6px;
    width: 1.2rem;
    height: 1.2rem;
}

.buttons {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-content: center;
    padding-right: 0.4rem;
}

#clients div {
    height: 26px;
}

.mobile #clients div {
    height: unset;
    //text-align: center;
}

#clients-container p {
    margin: 0.0em 5px 0.1em 5px;
    cursor: pointer;
    font-size: 16px;
    line-height: 0.5;
}

.mobile #clients-container p {
    line-height: 1;
    font-size: 16px;
}

#description-text {
    position: absolute;
    top:0;
    right: 0;
    width: 300px;
}

.mobile #description-text {
    position: relative;
    width: 100%;
}


#clients-container p:hover {
    font-style: italic;
}

#clients-container p.selected {
    color: black;
}

#description-content {
    color: black !important;
    font-size: 15px;
    padding-right: 1.5rem;
}

.mobile #description-content {
    color: black !important;
    font-size: 13px;
    padding-left: 17px;
    padding-right: 17px;
}

.random-container {
    cursor: pointer;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    touch-action: manipulation;
}

.object {
    opacity: 0.6;
    position: absolute;
    display: block;
  max-width: 330px;
    max-height: 330px;
    background-color: #fff;
    mix-blend-mode: soft-light;
    transition: opacity 1s, background-color 3s;
}

.object img {
  object-position: center;
}

.object.no-shadow {
  filter: none; /* Remove drop-shadow while transitioning z-index */
}

.object.small {
    max-width: 280px;
    max-height: 280px;
}

.object.large {
    max-width: 400px;
    max-height: 400px;
}


@media only screen and (max-width: 800px) {
  .random-container {
    cursor: pointer;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;

  }

    .object {
        width: auto;
        height: auto;
        max-height: 300px;
        max-width: 300px;
        opacity: 1;
      mix-blend-mode: normal;
    }

    .object.small {
        width: auto;
        height: auto;
        max-height: 260px;
        max-width: 260px;
    }

    .object.large {
        width: auto;
        height: auto;
        max-height: 330px;
        max-width: 330px;
    }
}
</style>